// @ts-nocheck
import { to_array } from "./to_array"

/**
 * Gets length of iterable.
 *
 * Converts to array and returns length. Primitives have length 1.
 *
 * @param a - Array, object, primitive, or undefined
 * @returns Length
 *
 * @example
 * ```ts
 * import { length } from "@pdfking/rfunc"
 *
 * length([1, 2, 3]) // 3
 * length({ a: 2, b: 3 }) // 2
 * length(1) // 1
 * length(undefined) // 0
 * ```
 */
export const length = a => to_array(a).length
